import { PreofferItem, PreofferItemResponse } from './preoffers.types';
import { localizedNameObject } from '@innowise-group/utilities';

export const mapPreofferItemResponseToPreofferItem = (data: PreofferItemResponse): PreofferItem => {
  const unitName = data.unit?.orgUnitName;
  const divisionName = data.division?.orgUnitName;
  const departmentName = data.department?.orgUnitName;
  const orgUnits = [unitName, divisionName, departmentName].filter(Boolean).join(',\n') || '-';

  return {
    id: data.id,
    candidateId: data.candidate.id,
    candidateFullName: localizedNameObject(data.candidate).localizedFullName,
    candidatePhoto: data.candidate.photoId?.toString(),
    statusName: data.preofferEvent.status.localizedName,
    statusGroup: data.preofferEvent.status.group,
    statusDate: data.preofferEvent.createdDate,
    isOnInterview: data.preofferEvent.isOnInterview,
    comment: data.comment,
    hrmEmail: data.candidate.hrmEmail,
    positionName: data.position?.translation || '-',
    grade: data.grade,
    unitName,
    divisionName,
    departmentName,
    orgUnits,
    responsibleEmployeeId: data.candidate.responsibleEmployee.employeeId,
    responsibleEmployeeFullName: localizedNameObject(data.candidate.responsibleEmployee).localizedFullName,
    responsibleEmployeePhoto:
      data.candidate.responsibleEmployee.photoId?.toString() || data.candidate.responsibleEmployee.miniPhotoHrmUrl,
    headId: data.head?.employeeId,
    headFullName: data.head ? localizedNameObject(data.head).localizedFullName : '-',
    headPhoto: data.head?.photoRt?.id?.toString() || data.head?.miniPhotoHrmUrl,
    resourceManagerId: data.resourceManager?.employeeId,
    resourceManagerFullName: data.resourceManager ? localizedNameObject(data.resourceManager).localizedFullName : '-',
    resourceManagerPhoto: data.resourceManager?.photoRt?.id?.toString() || data.resourceManager?.miniPhotoHrmUrl,
  };
};
